<template>
  <v-container fluid class="pa-0">
    <LoadingOverlay :isLoading="$store.state.hab.isLoading" />
    <div class="ma-4">
      <ClientNav />
      <v-row dense>
        <v-col cols="12" lg="3" xl="2">
          <ClientSide ref="clientData" />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <HABHeader
            :defaultMargin="defaultMargin"
            title="HAB PLAN Chart"
            text=" Needs to be administered today"
          />

          <v-divider :class="defaultMargin"></v-divider>

          <TabPage
            :defaultMargin="defaultMargin"
            @toggle-unsigned-page="toggleUnsignedPage"
            @toggle-page="togglePage"
            :page="page"
          />

          <div :class="defaultMargin">
            <CardList
              v-if="page === 'hab'"
              :habData="habData"
              @getHAB="fetch"
              :userDateToday="userDateToday"
            />
          </div>

          <div :class="defaultMargin">
            <History
              v-if="showPage"
              @getHAB="fetch"
              :isPageHistory="isPageHistory"
            />
          </div>

        </v-col>
      </v-row>
      <Foot />
    </div>
  </v-container>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";

import { mapActions, mapGetters, mapMutations } from "vuex";
import { setUserTz, tz } from "../../../../utils/timezone";
import moment from "moment";
import Foot from "@/components/Footer";

import HABHeader from "./header.vue";
import TabPage from "./TabPage.vue";
import CardList from "./CardList.vue";
import History from "./History.vue";
import LoadingOverlay from "@/components/shared/LoadingOverlay";

export default {
  components: {
    ClientNav,
    ClientSide,
    HABHeader,
    TabPage,
    CardList,
    Foot,
    LoadingOverlay,
    History,
  },
  
  data: () => ({
    page: "hab",
    habData: [],
    clientID: "",
    tempData: [],
    unsignedList: [],
    userDateToday: "",
    isPageHistory: true,
  }),

  computed: {
    ...mapGetters(["getUserTimezone", "getDefaultTz"]),

    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
      getHABSigned: "hab/getHABSigned",
    }),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    defaultMargin() {
      return this.$vuetify.breakpoint.xsOnly ? "ma-0 my-3" : "ma-3";
    },

    showPage(){
      return this.page == 'History' || 'unsigned' && this.page  != 'hab'
    },

  },

  async created() {
    this.clientID = this.$route.params.clientID;
    await this.onFetchHABSigned();
    this.fetch();
  },

  methods: {
    ...mapActions({
      fetchHABPlans: "hab/fetchHABPlans",
      fetchHABSigned: "hab/fetchHABSigned",
      addHABUnsigned: "hab/addHABUnsigned",
    }),

    ...mapGetters({
      getHABPlans: "hab/getHABPlans",
    }),

    ...mapMutations({
      setChat: "SET_CHAT",
      setLoading: "hab/SET_LOADING",
      setDisableButton: "hab/SET_DISABLE_BUTTON",
    }),

    async fetch() {
      this.habData = [];
      this.unsignedList = [];
      this.tempData =  await this.fetchHABPlans(this.clientID);
      //parse local date base on user timezone
      let tzdate = tz(new Date(), this.userTimezone);

      //SET USER LOCAL DATE
      this.userDateToday = tzdate;
      
      for (var i = 0; i < this.tempData.length; i++) {
        if(this.tempData[i]){
          //Allow only hab plan within Start and End Date
          let dateToday = moment(new Date(tzdate)).format("YYYY-MM-DD");
          let convertdateToday = new Date(dateToday).getTime();

          let habPlanStart = new Date(this.tempData[i].StartDate).getTime();
          let habPlanEnd = new Date(this.tempData[i].EndDate).getTime();

          if(convertdateToday >= habPlanStart && convertdateToday <= habPlanEnd){
            
            // Custom service attributes to prevent duplicate input fields
            this.tempData[i].newAssistance = "";
            this.tempData[i].newException = "";
            this.tempData[i].newPromptValue = 0;
            this.tempData[i].showPromptValue = false;
            this.tempData[i].newNotes = "";
            this.tempData[i].newSignature = "";
            this.tempData[i].error = "";
            
            let habSteps =
              this.tempData[i].Steps.length != 0
                ? this.tempData[i].Steps
                : "";

            // Check HAB STEPS
            habSteps.forEach((step) => {
              this.tempData[i].stepId = step._id;
              this.tempData[i].isSigned = this.isSigned(this.tempData[i]);
              let tempCard = Object.assign({}, this.tempData[i]);
              this.habData.push({
                ...tempCard,
                generatedId: uuidv4(),
                reveal: true,
                step: step.StepDescription,
              });
              
              if (!tempCard.isSigned) {
                this.unsignedList.push({
                  ...tempCard
                });
              }

            });

            // TODO add Unsigned
          const unsignedData = {
            date: new Date(),
            clientID: this.clientID,
            services: this.unsignedList.map(
              ({ _id, stepId }) => ({
                _id, 
                StepID: stepId,
              })
            ),
          };

          this.addHABUnsigned(unsignedData);

          }
        }
      }
      this.setDisableButton(false);
    },

    onFetchHABSigned(){
      let tzdate = tz(new Date(), this.userTimezone);
      let dateToday = moment(new Date(tzdate)).format("YYYY-MM-DD");
      let dataFilter = {
        clientID: this.clientID,
        dateToday: dateToday,
        timezone: this.userTimezone
      }
      this.fetchHABSigned(dataFilter);
    },

    isSigned: function(hab) {
      //parse local date base on user timezone
      let tzdate = tz(new Date(), this.userTimezone);
      let result = false;
      this.getHABSigned
        .filter(
          (item) =>
            item.HABPlan == hab._id &&
            item.Step === hab.stepId &&
            item.customDate ==  moment(new Date(tzdate)).format("YYYY-MM-DD")
        )
        .forEach(() => {
          result = true;
        });
      return result;
    },

    togglePage() {
      if (this.page === "hab") {
        this.page = "History";
        //this.currentPage(this.page);
      } else if (this.page === "History") {
        this.page = "hab";
        this.isPageHistory = true
       // this.currentPage(this.page);
      } else {
        this.page = "hab";
        this.isPageHistory = true
        //this.currentPage(this.page);
      }
    },

    toggleUnsignedPage() {
      //this.currentPage(page);
      this.page = "Unsigned";
      this.isPageHistory = false
    },
    /*
    currentPage(page) {
      this.$router.push({ name: "HABChart", params: { page: page } }, () => {});
      this.page = page;
    },
    */
  }
}
</script>
